export const iconFontAwesomeDevicesHardwareSatellite = (
	<i className="fa-solid fa-satellite"></i>
);
